module.exports = __webpack_public_path__ + "img/series_02.91b3c309.png";